export default __webpack_public_path__ + "static/media/img16.0cdf59ff.PNG";